<td iTableTd>
  <div class="inline-flex items-center gap-2">
    <app-campaign-type-badge [campaignType]="strategy().campaignType" />
    <app-strategy-link [strategyId]="strategy().strategyId" />
  </div>
</td>
<td iTableTd class="text-sm font-medium">{{ strategy().acosTarget | percent }}</td>
<td iTableTd>
  <IToggle
    [checked]="isPromoDaysBoostEnabled()"
    [disabled]="!isPromoDaysEligible()"
    (checkedChange)="toggleBoost()"
    [loading]="promoDaysCallLoading()"
    [iTooltip]="ineligibleReason()"
  />
</td>
<td iTableTd>
  <app-optimizer-description
    [strategy]="strategy()"
    [accountMarketplace]="accountMarketplace()"
    [isReadOnly]="!!isReadOnly()"
    [dateRange]="dateRange()!"
  />
</td>
